<div
  class="p-2 light-blue-header d-flex flex-row justify-content-between modal-header"
>
  <div class="p-2 modal-title"><h5>Volunteer Test - Scheduling</h5></div>
  <button
    class="p-0 m-0 btn"
    style="line-height: 0.8; color: white"
    (click)="onClose()"
    aria-label="Close"
  >
    <i class="fa fa-window-close"></i>
  </button>
</div>

<div
  class="container-fluid busy-overlay-parent p-3"
  [ngClass]="bProcessing ? 'disabled' : ''"
>
  <div *ngIf="bProcessing" class="font-weight-bold busy-overlay">
    <i class="fa fa-spinner fa-spin"></i>&nbsp;Please wait...
  </div>
  <form #testForm="ngForm" class="card p-2">
    <div *ngIf="errorMsg" class="alert alert-danger mb-3">
      {{ errorMsg | shorten: 120:"..." }}
    </div>
    <div class="input-group input-group-sm">
      <div class="p-2">
        <label for="stageSelect" class="form-label">Stage:</label>
        <select
          name="stage"
          class="form-control"
          id="stageSelect"
          [(ngModel)]="tmpTask.stage"
          #stageSelect="ngModel"
          required
          [ngClass]="{
            'invalid-input':
              stageSelect.invalid && (stageSelect.dirty || stageSelect.touched)
          }"
        >
          <option *ngFor="let stage of stages" [ngValue]="stage">
            {{ stage }}
          </option>
        </select>
        <span *ngIf="stageSelect.invalid" class="text-danger small font-italic"
          >* Required</span
        >
      </div>
      <div class="p-2">
        <label for="buildingIdSelect" class="form-label">Building:</label>
        <select
          name="buildingId"
          class="form-control"
          id="buildingIdSelect"
          [disabled]="!!tmpTask.id"
          #buildingIdSelect="ngModel"
          required
          [(ngModel)]="tmpTask.buildingId"
          (ngModelChange)="onBuildingIdChanged($event)"
          [ngClass]="{
            'invalid-input':
              buildingIdSelect.invalid &&
              (buildingIdSelect.dirty || buildingIdSelect.touched)
          }"
        >
          <option
            *ngFor="let buildingInfo of buildingInfoArray"
            [ngValue]="buildingInfo.id"
          >
            {{ buildingInfo.id }} - {{ buildingInfo.name }}
          </option>
        </select>
        <span
          *ngIf="buildingIdSelect.invalid"
          class="text-danger small font-italic"
          >* Required</span
        >
      </div>
      <div class="d-flex flex-wrap justify-content-between">
        <div class="d-flex flex-wrap">
        <div class="p-2">
          <label for="volunteerIdSelect" class="form-label">Volunteer:</label>
          <select
            name="volunteerId"
            class="form-control"
            id="volunteerIdSelect"
            [disabled]="
              (tmpTask.status > NOT_STARTED && tmpTask.volunteerId) ||
              bLoadingVolunteers
            "
            #volunteerIdSelect="ngModel"
            required
            [(ngModel)]="tmpTask.volunteerId"
            (ngModelChange)="onVolunteerIdChanged($event)"
            [ngClass]="{
              'invalid-input':
                volunteerIdSelect.invalid &&
                (volunteerIdSelect.dirty || volunteerIdSelect.touched)
            }"
          >
            <option
              *ngFor="let volunteer of volunteers"
              [ngValue]="volunteer.id"
            >
              {{
                volunteer.name +
                  (volunteer.email ? " (" + volunteer.email + ")" : "")
              }}
            </option>
          </select>
          <i *ngIf="bLoadingVolunteers" class="fa fa-spinner fa-spin"></i>
          <span
            *ngIf="volunteerIdSelect.invalid"
            class="text-danger small font-italic"
            >* Required</span
          >
        </div>
        
        <div class="p-2">
          <label for="scheduledDateInput" class="form-label"
            >Schedule Date:</label
          >
          <input
            type="date"
            name="scheduledDate"
            class="form-control"
            id="scheduledDateInput"
            [(ngModel)]="tmpTask.scheduledDate"
            #scheduledDateInput="ngModel"
            required
            [ngClass]="{
              'invalid-input':
                scheduledDateInput.invalid &&
                (scheduledDateInput.dirty || scheduledDateInput.touched)
            }"
          />
          <span
            *ngIf="scheduledDateInput.invalid"
            class="text-danger small font-italic"
            >* Required</span
          >
        </div>
        </div>
        
        <div class="p-2">          
          <app-volunteer-task-series #taskSeries
              [series]="series"
              (maxCnt)="onSeriesMaxCntChange($event)"
              (interval)="onSeriesIntervalChange($event)"
              (duration)="onSeriesDurationChange($event)"
              >
          </app-volunteer-task-series>
        </div>
      </div>
    </div>

    <div class="p-2">
      <span class="gray font-italic pl-2">Notes</span>
      <textarea
        name="notes"
        [(ngModel)]="tmpTask.notes"
        rows="4"
        class="w-100 border"
        style="resize: none"
        #notes="ngModel"
        [ngClass]="{
          'invalid-input': notes.invalid && (notes.dirty || notes.touched)
        }"
      ></textarea>
    </div>

    <div class="p-2 w-100">
      <div class="d-flex flex-row justify-content-between">
      <label class="form-label"
        ><i *ngIf="bAvailPointsLoading" class="fa fa-spinner fa-spin mr-2"></i
        >Test Points:
      </label>
      <div *ngIf="!task?.id">
        <div class="text-right">
        <label class="form-label">
          <input type="checkbox" #customTestParamCheckbox>
          Custom test parameters
        </label>
        </div>
        <div *ngIf="customTestParamCheckbox.checked && taskConfig?.testPoint">
          <app-volunteer-task-point-test-params #taskPointTestParams 
            [config]="taskConfig.testPoint" [bFormMode]="true">
          </app-volunteer-task-point-test-params>
        </div>
      </div>
      </div>
      <div
        class="btn-group w-100 py-1 px-0"
        dropdown
        [insideClick]="true"
        [(isOpen)]="taskPointChoicesOpen"
      >
        <button
          [disabled]="bAvailPointsLoading"
          id="avail-points-dropdown"
          dropdownToggle
          type="button"
          class="btn btn-light w-100 p-1"
          aria-controls="dropdown-basic"
        >
          <div class="d-flex flex-row justify-content-between w-100">
            <div class="d-flex flex-row w-100">
              <div class="d-flex flex-wrap">
                <div
                  *ngFor="
                    let taskPtChoice of taskPointChoices
                      | filterByImpure: ['bSelected']:true
                  "
                  class="badge {{
                    taskPtChoice.volPoint ? 'status-complete' : 'badge-warning'
                  }} p-1 m-1"
                  [attr.title]="
                    taskPtChoice.taskPoint?.floorAndDescript ||
                    taskPtChoice.taskPoint?.locationDescription
                  "
                >
                  {{ taskPtChoice.taskPoint.pointId }}
                  <div
                    class="badge badge-danger"
                    role="button"
                    (click)="
                      $event.stopPropagation();
                      onToggleTaskPtChoice(taskPtChoice)
                    "
                  >
                    X
                  </div>
                </div>
              </div>
            </div>
            <i
              class="fa fa-chevron-{{
                taskPointChoicesOpen ? 'right' : 'down'
              }} mx-1 my-auto"
            ></i>
          </div>
        </button>
        <ul
          id="dropdown-basic"
          *dropdownMenu
          class="dropdown-menu"
          role="menu"
          aria-labelledby="avail-points-dropdown"
        >
          <li role="menuitem" *ngFor="let taskPtChoice of taskPointChoices">
            <div class="dropdown-item mx-0 px-2">
              <div class="card p-1 text-left">
                <div class="d-flex flex-row px-1">
                  <div
                    class="d-flex flex-row"
                    role="button"
                    (click)="onToggleTaskPtChoice(taskPtChoice)"
                  >
                    <ng-container *ngIf="!taskPtChoice.scoutPoint?.disabled; else taskPtChoiceDisabled">
                    <input
                      type="checkbox"
                      [ngModel]="taskPtChoice.bSelected"
                      class="mr-2"
                      [ngModelOptions]="{ standalone: true }"
                    />
                    <div
                      class="badge {{
                        taskPtChoice.volPoint
                          ? 'status-complete'
                          : 'badge-warning'
                      }} my-auto p-2"                      
                    >
                      {{ taskPtChoice.taskPoint?.pointId }}
                    </div>
                    </ng-container>
                    <ng-template #taskPtChoiceDisabled>
                      <div
                      class="badge badge-warning my-auto p-2"
                    >
                    <span style="text-decoration: line-through;">
                      {{ taskPtChoice.taskPoint?.pointId }}
                    </span>
                      <span class="text-secondary font-italic my-auto ml-2">(scout point is disabled)</span>
                    </div>                    
                    </ng-template>
                  </div>
                  <div class="font-italic ml-2">
                    {{ taskPtChoice.taskPoint?.floorAndDescript }}
                  </div>
                </div>
                <div
                  *ngIf="task.buildingId && task.buildingId != taskPtChoice.taskPoint?.buildingId"
                  class="text-danger font-italic font-weight-bold"
                >
                  <i class="fa fa-exclamation-triangle text-warning mr-2"></i>
                  Task point building is '{{
                    taskPtChoice.taskPoint?.buildingId
                  }}'
                </div>
                <div class="text-wrap pt-1 px-1">
                  {{ taskPtChoice.taskPoint?.locationDescription }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="d-flex flex-row justify-content-between w-100">
    <div>
      <div *ngIf="bNoWaypointsFound" class="text-warning font-italic small">
        No waypoints defined in database for path.
      </div>
    </div>
    <div>
      <div
        class="btn-group"
        dropdown
        [isDisabled]="bProcessing || bLoadingPointIds"
      >
        <button
          [disabled]="
            bProcessing ||
            bLoadingPointIds ||
            !(testForm.dirty || taskPointsModified || taskSeries.form.dirty) ||
            testForm.invalid
          "
          (click)="onSave()"
          class="btn btn-primary"
        >
          Save
        </button>
        <ng-container *ngIf="task?.id">
          <button
            id="actions-btn"
            dropdownToggle
            class="btn btn-secondary dropdown-toggle"
            aria-controls="actions-dropdown"
          >
            <span class="caret"></span>
            <span class="sr-only visually-hidden">Additional Actions</span>
          </button>
          <ul
            id="actions-dropdown"
            *dropdownMenu
            style="min-width: 4em"
            class="dropdown-menu px-1 py-1 m-0"
            role="menu"
            aria-labelledby="actions-btn"
          >
            <li role="menuitem">
              <button
                *ngIf="tmpTask.id"
                [disabled]="bProcessing || bLoadingPointIds"
                (click)="onDelete()"
                class="btn btn-warning mx-auto text-nowrap"
              >
                <i class="fa fa-times-circle text-danger mr-1"></i>Delete
              </button>
            </li>
          </ul>
        </ng-container>
      </div>
      &nbsp;
      <button (click)="onClose()" class="btn btn-secondary">Close</button>
    </div>
  </div>
</div>
